module.exports = __webpack_public_path__ + "media/images/icon_favorite_white-6e00ba21d86be1ef1d14311288777b98.png";